import { FC, ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HolderOutlined } from "@ant-design/icons";
import { DragButton, FieldRow } from "./styles";
import { UniqueIdentifier } from "@dnd-kit/core";

interface ISimpleSortableItemWithButton {
  children: ReactNode;
  id: string;
  activeId?: UniqueIdentifier | null;
  disabled?: boolean;
  className?: string;
  dragClassName?: string;
  btnClassName?: string;
  btnShowInHover?: boolean;
  btnShowIsAbsolute?: boolean;
}

const SimpleSortableItemWithButton: FC<ISimpleSortableItemWithButton> = ({
  children,
  id,
  activeId,
  disabled,
  className,
  dragClassName,
  btnClassName,
  btnShowInHover,
  btnShowIsAbsolute,
}) => {
  const {
    attributes,
    listeners,
    transition,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    isDragging,
  } = useSortable({
    id: id,
  });

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition
  };

  return (
    <FieldRow
      key={`key-${id}`}
      ref={setNodeRef}
      style={style}
      className={id === activeId ? dragClassName : className}
      showinhover={btnShowInHover}
      isabsolute={btnShowIsAbsolute}
    >
      {!disabled && (
        <DragButton
          isgrabbing={`${id === activeId}`}
          className={`hovershow ${btnClassName}`}
          isabsolute={btnShowIsAbsolute}
          {...attributes}
          {...listeners}
          ref={setActivatorNodeRef}
        >
          <HolderOutlined className="iconDrag" />
        </DragButton>
      )}
      {children}
    </FieldRow>
  );
}

export default SimpleSortableItemWithButton;
